import { coordinateValueSwitch } from "./coordinateValueSwitch";

export const vectorReading = (vectors, diffVectors, configParams) => {
  let maxDiffVector = {};
  const faceParts = Object.keys(vectors);

  if (faceParts?.length > 0) {
    for (const facePart of faceParts) {
      maxDiffVector[`${facePart}`] = null;
      let counter = 0;

      if (vectors[`${facePart}`]?.length > 1) {
        let referenceVector = null;

        for (const attempt of vectors[`${facePart}`]) {
          if (counter === 0) {
            referenceVector = attempt.measure;
          } else {
            const measureDiff = [];

            if (referenceVector?.length > 0) {
              // eslint-disable-next-line no-loop-func
              attempt.measure.forEach((measure, measureIndex) => {
                const pointDiffs = [];

                const findElementByIndex = referenceVector.find(
                  (refMeasure, refMeasureIndex) =>
                    refMeasureIndex === measureIndex
                );

                if (findElementByIndex) {
                  findElementByIndex.forEach((refPoints, refPointsIndex) => {
                    const findPointsByIndex = measure.find(
                      (currentPoints, currentPointsIndex) =>
                        currentPointsIndex === refPointsIndex
                    );

                    pointDiffs.push(refPoints - findPointsByIndex);
                  });

                  const threeDimensionDistance = Math.sqrt(
                    pointDiffs.reduce((acc, el) => acc + Math.pow(el, 2), 0)
                  );

                  measureDiff.push({
                    pointDiffs,
                    distance: threeDimensionDistance,
                  });
                }
              });
            }

            const avgDistance =
              measureDiff.reduce((acc, el) => acc + el.distance, 0) /
              measureDiff.length;

            diffVectors[`${facePart}`].push({ measureDiff, avgDistance });
          }
          counter = counter + 1;
        }
      }
    }
  }

  for (const facePart of faceParts) {
    if (diffVectors[`${facePart}`]?.length > 0) {
      const maxDiffFacePartMeasure = diffVectors[
        `${facePart}`
      ].reduce((max, obj) => (obj.avgDistance > max.avgDistance ? obj : max));

      maxDiffVector[`${facePart}`] = maxDiffFacePartMeasure;
    }
  }

  // Tomemos la boca como punto de referencia y un promedio de sus puntos

  if (maxDiffVector.mouth?.measureDiff?.length > 0) {
    const xAxisValue =
      maxDiffVector.mouth.measureDiff.reduce((acc, el) => {
        return acc + el.pointDiffs[0];
      }, 0) / maxDiffVector.mouth.measureDiff.length;

    const yAxisValue =
      maxDiffVector.mouth.measureDiff.reduce((acc, el) => {
        return acc + el.pointDiffs[1];
      }, 0) / maxDiffVector.mouth.measureDiff.length;

    const movementDir = coordinateValueSwitch(
      xAxisValue,
      yAxisValue,
      configParams
    );

    return movementDir;
  }
};
